import { makeStyles } from '@material-ui/core';

import { pdvColor, pdvLabelFont, pdvRadius } from '../tokens';

export const useStyles = makeStyles({
  list: { display: 'flex', flexWrap: 'wrap', gap: 8 },
  /* the toggle sits in a bordered capsule that ends with its last option */
  groupList: {
    flexWrap: 'nowrap',
    alignItems: 'center',
    gap: 4,
    minHeight: 42,
    boxSizing: 'border-box',
    border: `1px solid ${pdvColor.border}`,
    borderRadius: pdvRadius.pill
  },
  item: {
    ...pdvLabelFont,
    flex: 'none',
    border: 0,
    borderRadius: pdvRadius.pill,
    background: 'none',
    color: pdvColor.textSecondary,
    whiteSpace: 'nowrap',
    cursor: 'pointer',
    '&:focus-visible': {
      outline: 'none',
      boxShadow: `0 0 0 2px ${pdvColor.brand}`
    },
    '&:disabled': { opacity: 0.4, cursor: 'not-allowed' }
  },

  /* soft: Manage Attributes tabs, report modes */
  soft: {
    height: 40,
    padding: '8px 16px',
    '&:hover:not(:disabled)': { background: pdvColor.surfacePage }
  },
  softOn: {
    color: pdvColor.brand,
    '&, &:hover:not(:disabled)': { background: pdvColor.brandSoft }
  },

  /* solid: Rep Feedback status tabs */
  solid: {
    padding: '10px 12px',
    '&:hover:not(:disabled)': { background: pdvColor.surfaceSubtle }
  },
  solidOn: {
    color: pdvColor.textOnBrand,
    '&, &:hover:not(:disabled)': { background: pdvColor.brand }
  },

  /* group: the Everyone / Assigned to me toggle */
  group: {
    padding: '8px 16px',
    lineHeight: '24px',
    '&:hover:not(:disabled)': { background: pdvColor.surfaceSubtle }
  },
  groupOn: {
    color: pdvColor.brandStrong,
    '&, &:hover:not(:disabled)': { background: pdvColor.brandSofter }
  }
});
